import * as React from 'react'
import clx from 'classnames'

type Props = {
  label?: string
  value?: string
  name?: string
  placeholder?: string
  error?: string | boolean
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  className?: string
  disabled?: boolean
  suffix?: string
  rows?: number
}

export const FieldsetTextarea = ({
  label,
  value,
  name,
  placeholder,
  onChange,
  error,
  className,
  disabled = false,
  suffix,
  rows = 4,
}: Props) => {
  const hasError = Boolean(error)

  return (
    <fieldset className="tw-d-form-control tw-w-full">
      {label && (
        <label className="tw-mb-0 tw-px-1 tw-pb-0.5 tw-text-sm tw-font-medium">
          {label}
        </label>
      )}
      <div
        className={clx(
          `tw-d-input tw-d-input-primary tw-h-auto tw-flex tw-items-center tw-gap-2 tw-rounded-[4px] tw-border-content-base/20 !tw-px-3 focus-within:!tw-border-content-base/20 focus-within:!tw-text-content-base ${disabled ? 'tw-text-content-base/30' : 'tw-text-input'}`,
          className,
          {
            '[&:not(:focus-within)]:tw-d-input-error': hasError,
            '!tw-border-base-200 !tw-bg-base-200': disabled,
          },
        )}
      >
        <textarea
          className="tw-peer tw-w-full tw-w-full"
          value={value || ''}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          rows={rows}
        />
        {suffix && <span>{suffix}</span>}
      </div>

      {hasError && typeof error === 'string' && (
        <span className="tw-text-xs tw-font-medium tw-text-error peer-focus-within:tw-opacity-0">
          {error}
        </span>
      )}
    </fieldset>
  )
}
